/**
 * Alert Type (Gate Key) Enum
 * Represents the gate keys in the alerts API gates array
 */
export enum AlertTypeEnum {
  COMPLETE_NAFATH = 'complete_nafath',
  NAFATH_EXPIRATION = 'nafath_expiration',
  MINOR_PROXY = 'minor_proxy',
  COMPLETE_KYC = 'complete_kyc',
  KYC_EXPIRATION = 'kyc_expiration',
  AML = 'aml',
  HAS_BANK_ACCOUNT = 'has_bank_account',
}
